(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shellback-personalization"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sb-vintage-santa'))customElements.define('sb-vintage-santa',class extends HTMLElement{
connectedCallback(){
this.abort=new AbortController();this.scope=this.closest('product-info')||this.closest('section');this.form=this.closest('form');this.box=this.querySelector('fieldset');this.fields=[...this.querySelectorAll('input,textarea')];
this.check=()=>this.fields[0].setCustomValidity(!this.box.disabled&&!this.fields.some(f=>f.value.trim())?this.dataset.error:'');
this.sync=()=>{const picker=this.scope.querySelector('variant-selects select');const radio=this.scope.querySelector('variant-selects input:checked');const selected=picker?.value||radio?.value||this.dataset.initial;this.box.disabled=selected!=='Personalized back';this.box.hidden=this.box.disabled;this.check();};
this.scope.addEventListener('change',this.sync,{signal:this.abort.signal});this.addEventListener('input',this.check,{signal:this.abort.signal});
this.form.addEventListener('submit',e=>{this.sync();if(!this.box.disabled&&!this.fields[0].checkValidity()){e.preventDefault();e.stopImmediatePropagation();this.fields[0].reportValidity();}},{capture:true,signal:this.abort.signal});this.sync();
}disconnectedCallback(){this.abort?.abort();}
});
  } catch(e) { console.error(e); }
})();

})();
